import { render, staticRenderFns } from "./embedList.vue?vue&type=template&id=0704bd50&"
import script from "./embedList.vue?vue&type=script&lang=js&"
export * from "./embedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports